import { IconWrapper } from '../runtime';
export default IconWrapper('admin-backstage', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 7.99976H14.2533M5 1.74976V4.74976M11 6.49976V9.49976M5 11.2498V14.2498M1.75 3.24976H14.2533M1.75 12.7498H14.2533",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});